import { uniqueId } from 'lodash-es';
import { useState } from 'react';
import { Tooltip } from 'reactstrap';
import { getTranslation } from 'src/utilities/translator';

const CreditCardWarning = (props: any) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [id] = useState(uniqueId('credit-card-warning-'));

  return (
    <>
      <div
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
      >
        <svg
          id={id}
          width="42"
          height="42"
          viewBox="0 0 42 42"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <circle
            cx="21"
            cy="21"
            r="19"
            fill="#FBEAB3"
            stroke="white"
            strokeWidth="4"
          />
          <path
            d="M19.3475 10.9756C20.0819 9.6748 21.9181 9.6748 22.6525 10.9756L31.7415 27.0732C32.476 28.374 31.5579 30 30.089 30H11.911C10.4421 30 9.52403 28.374 10.2585 27.0732L19.3475 10.9756Z"
            fill="#F7D250"
          />
          <circle cx="21" cy="27" r="1" fill="#C1A119" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21 15C21.5523 15 22 15.4477 22 16V22C22 22.5523 21.5523 23 21 23C20.4477 23 20 22.5523 20 22V16C20 15.4477 20.4477 15 21 15Z"
            fill="#C1A119"
          />
        </svg>
      </div>
      <Tooltip target={id} isOpen={showTooltip}>
        {getTranslation('virtualCard_lowLimit_tooltip')}
      </Tooltip>
    </>
  );
};

export default CreditCardWarning;
